// src/api/educationService.ts
import api from './config';

export interface Education {
  id?: number;
  year_start: number;
  year_end: number | null;  // was: number 
  //year_end: number;
  degree: string;
  specialization: string;
  university: string;
  location: string;
  description?: string;
}

export const getEducation = async (): Promise<Education[]> => {
  const response = await api.get('/api/education/');
  return response.data.data;
};

export const getEducationById = async (id: number): Promise<Education> => {
  const response = await api.get(`/api/education/${id}`);
  return response.data.data;
};

// Add CRUD operations for future admin functionality
export const createEducation = async (education: Omit<Education, 'id'>): Promise<Education> => {
  const response = await api.post('/api/education/', education);
  return response.data.data;
};

export const updateEducation = async (id: number, education: Partial<Education>): Promise<Education> => {
  const response = await api.put(`/api/education/${id}`, education);
  return response.data.data;
};

export const deleteEducation = async (id: number): Promise<void> => {
  await api.delete(`/api/education/${id}`);
};
